// extracted by mini-css-extract-plugin
module.exports = {"partnerListWrapper":"u+cgx","collapsedPartnerList":"_98sAf","partnerList":"zZEPM","listTitle":"fXZQx","partnerListTitle":"QFTiZ"};